export default __webpack_public_path__ + "affb76e2943f5cf1ba5659265431bdc1.jpeg";